export default {
  title: {
    id: 'bo_sellers-buyback-opportunities-title',
    defaultMessage: 'Trade-in Opportunities',
  },
}
